import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase/app";
import "firebase/auth";
import db from "../firebase/firebaseInit";
import emailjs from 'emailjs-com';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    blogPosts: [],
    blogDrafts: [],
    comments: [],
    postLoaded: null,
    blogHTML: "Write your blog title here...",
    blogTitle: "",
    blogPhotoName: "",
    currentBlogID: null,
    blogPhotoFileURL: null,
    blogPhotoPreview: null,
    editPost: null,
    user: null,
    profileAdmin: null,
    profileEmail: null,
    profileFirstName: null,
    profileLastName: null,
    profileMenu: null,
    profileUsername: null,
    profileId: null,
    profileInitials: null,
    subscribed: null,
  },
  getters: {
    blogPostsFeed(state) {
      return state.blogPosts.slice(0, 2)
    },
    blogPostsCards(state) {
      return state.blogPosts.slice(2, 6)
    }
  },
  mutations: {
    newBlogPost(state, payload) {
      state.blogHTML = payload;
    },
    updateBlogTitle(state, payload) {
      state.blogTitle = payload;
    },
    fileNameChange(state, payload) {
      state.blogPhotoName = payload;
    },
    createFileURL(state, payload) {
      state.blogPhotoFileURL = payload;
    },
    openPhotoPreview(state) {
      state.blogPhotoPreview = !state.blogPhotoPreview;
    },
    toggleEditPost(state, payload) {
      state.editPost = payload;
    },
    setBlogState(state, payload) {
      state.blogTitle = payload.blogTitle;
      state.blogHTML = payload.blogHTML;
      state.blogPhotoFileURL = payload.blogCoverPhoto;
      state.blogPhotoName = payload.blogCoverPhotoName;
    },
    filterBlogPost(state, payload) {
      state.blogPosts = state.blogPosts.filter((post) => post.blogID !== payload);
    },
    filterBlogDraft(state, payload) {
      state.blogDrafts = state.blogDrafts.filter((post) => post.blogID !== payload);
    },
    setProfileAdmin(state, payload) {
      state.profileAdmin = payload;
    },
    setProfileInfo(state, doc) {
      state.profileId = doc.id;
      state.profileEmail = doc.data().email;
      state.profileFirstName = doc.data().firstName;
      state.profileLastName = doc.data().lastName;
      state.profileUsername = doc.data().username;
      state.subscribed = doc.data().subscribed;
    },
    updateUser(state, payload) {
      state.user = payload;
    },
    setProfileInitials(state) {
      state.profileInitials =
        state.profileFirstName.match(/(\b\S)?/g).join("") +
        state.profileLastName.match(/(\b\S)?/g).join("");
    },
    changeFirstName(state, payload) {
      state.profileFirstName = payload;
    },
    changeLastName(state, payload) {
      state.profileLastName = payload;
    },
    changeUsername(state, payload) {
      state.profileUsername = payload;
    },
    changeSubscription(state, payload) {
      state.subscribed = payload;
    },
    setCurrentBlogID(state, payload) {
      state.currentBlogID = payload;
    },
  },
  actions: {
    async notifySubscribers() {
      const postId = await (await db.collection('blogPosts').orderBy('date', 'desc').limit(1).get());
      const dataBase = await db.collection('users');
      const dbResults = await dataBase.get();
      postId.forEach((id) => {
        dbResults.forEach((doc) => {
          if (doc.data().subscribed) {
            try {
              console.log(doc.data().email);
              emailjs.send('service_5cpc2wg', 'template_c7iq8is',
              {
                to_email: doc.data().email,
                to_name: doc.data().firstName,
                from_name_short: "Isaac",
                from_name: "Isaac Allen",
                url: `https://isaacallen.dev/view-blog/${id.data().blogID}`,
              },
              'O_WDgE73_418QN_zE');
            } catch(error) {
                console.log({error})
            }
          }
        });
      });
      
    },
    async getCurrentUser({commit}, user) {
      const dataBase = await db.collection('users').doc(firebase.auth().currentUser.uid);
      const dbResults = await dataBase.get();
      commit("setProfileInfo", dbResults);
      commit("setProfileInitials");
      const token = await user.getIdTokenResult();
      const admin = await token.claims.admin;
      commit('setProfileAdmin', admin);
    },
    async getPost({state}) {
      const dataBase = await db.collection('blogPosts').orderBy('date', 'desc');
      const dbResults = await dataBase.get();
      dbResults.forEach((doc) => {
        if (!state.blogPosts.some(post => post.blogID === doc.id)) {
          const data = {
            blogID: doc.data().blogID,
            blogHTML: doc.data().blogHTML,
            blogCoverPhoto: doc.data().blogCoverPhoto,
            blogTitle: doc.data().blogTitle,
            blogDate: doc.data().date,
            blogCoverPhotoName: doc.data().blogCoverPhotoName,
          };
          state.blogPosts.push(data);
        }  
      });
      state.postLoaded = true;
    },
    async getDraft({state}) {
      const dataBase = await db.collection('blogDrafts').orderBy('date', 'desc');
      const dbResults = await dataBase.get();
      dbResults.forEach((doc) => {
        if (!state.blogPosts.some(post => post.blogID === doc.id)) {
          const data = {
            blogID: doc.data().blogID,
            blogHTML: doc.data().blogHTML,
            blogCoverPhoto: doc.data().blogCoverPhoto,
            blogTitle: doc.data().blogTitle,
            blogDate: doc.data().date,
            blogCoverPhotoName: doc.data().blogCoverPhotoName,
          };
          state.blogDrafts.push(data);
          state.drafts++;
        }  
      });
      state.postLoaded = true;
      state.drafts = true;
    },
    async loadComments({state}) {
      const dataBase = await db.collection('comments').orderBy('time', 'asc');
      const dbResults = await dataBase.get();
      state.comments = [];
      dbResults.forEach((doc) => {
        if (state.currentBlogID === doc.data().blogID) {
          const data = {
            comment: doc.data().comment,
            time: doc.data().time,
            username: doc.data().userID,
            firstName: doc.data().firstName,
            lastName: doc.data().lastName,
          };
          console.log(data);
          state.comments.push(data);
        }  
      });
    },
    async updatePost({commit, dispatch}, payload) {
      commit('filterBlogPost', payload);
      await dispatch("getPost");
    },
    async deletePost({commit}, payload) {
      const getPost = await db.collection('blogPosts').doc(payload);
      console.log(getPost.data);
      await getPost.delete();
      commit('filterBlogPost', payload);
    },
    async deleteDraft({commit}, payload) {
      const getPost = await db.collection('blogDrafts').doc(payload);
      await getPost.delete();
      commit('filterBlogDraft', payload);
    },
    async updateUserSettings({commit, state}) {
      const dataBase = await db.collection('users').doc(state.profileId);
      await dataBase.update({
        firstName: state.profileFirstName,
        lastName: state.profileLastName,
        username: state.profileUsername,
        subscribed: state.subscribed,
      });
      commit("setProfileInitials");
    }
  },
  modules: {
  }
})
